import paymentCloudImg from '@p2p/assets/img/payment-cloud.png';
import paymentMailImg from '@p2p/assets/img/payment-mail.png';
import { Button, CloseButton, Typography } from '@p2p/components';
import { MainContainer, usePaymentData, useTimeEndNotification } from '@p2p/entities/payment';
import { PaymentCancelModal, usePaymentTemplate } from '@p2p/entities/templates';
import { MSP_PAGE, MSP_PAYMENT_SENT_SESSION_KEY, PaymentType } from '@p2p/shared/constants';
import { useMount } from '@p2p/shared/hooks';
import { useState } from 'react';

import { BillBlock, InfoBlock, PdfWarningModal, Section } from './components';
import styles from './MatchingDetailsPayment.module.scss';

// P2P-2742: игрок нажал "Деньги отправлены" и ушёл в банковское приложение;
// вернувшись, он часто попадает на перезагруженную страницу -- без этой отметки
// блок загрузки чека снова становится серым и не реагирует на нажатия.
const isPaymentSent = (orderId: string) => {
  try {
    return sessionStorage.getItem(MSP_PAYMENT_SENT_SESSION_KEY) === orderId;
  } catch {
    return false;
  }
};

export const MatchingDetailsPayment = () => {
  const { order, pageSettings } = usePaymentData();
  useTimeEndNotification();
  const { setActiveIndex } = usePaymentTemplate();
  const [isCheckPayment, setIsCheckPayment] = useState(() => isPaymentSent(order.id));
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  const handleCheckPayment = () => {
    try {
      sessionStorage.setItem(MSP_PAYMENT_SENT_SESSION_KEY, order.id);
    } catch {
      /* приватный режим / storage недоступен -- не критично */
    }

    setIsCheckPayment(true);
  };

  const handleClose = () => {
    setIsCancelModalOpen(true);
  };

  useMount(() => {
    setActiveIndex(2);
  });

  const isSBP = order.requisite.payment_type === PaymentType.PAYMENT_TYPE_SBP;
  const isC2C = order.requisite.payment_type === PaymentType.PAYMENT_TYPE_C2C;

  return (
    <MainContainer className={styles.container} marginTop="2xl" maxWidth="700px">
      <div className={styles.header}>
        {isC2C && <Typography variant="h1">Оплата по номеру карты</Typography>}
        {isSBP && <Typography variant="h1">Оплата через СБП</Typography>}
        <CloseButton onClick={handleClose} />
      </div>
      <div className={styles.sectionsContainer}>
        <Section
          title="Отправьте указанную сумму"
          logo={paymentMailImg}
          active
          checked={isCheckPayment}
        >
          <InfoBlock isShortView={isCheckPayment} handleShortView={handleCheckPayment} />
        </Section>
        <Section title={`Загрузите\nчек об оплате`} logo={paymentCloudImg} active={isCheckPayment}>
          <BillBlock isShortView={!isCheckPayment} />
        </Section>
      </div>
      <Button variant="outlined" onClick={handleClose} className={styles.cancelButton}>
        Отменить операцию
      </Button>
      <PdfWarningModal orderId={order.id} show={!!order.show_pdf_warning} />
      <PaymentCancelModal
        isActive={isCancelModalOpen}
        setIsActive={setIsCancelModalOpen}
        pageSettings={pageSettings}
        orderId={order.id}
        cancelPath={`${MSP_PAGE}/${order.id}/canceled`}
        orderStatus={order.status}
      />
    </MainContainer>
  );
};
